import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service';
import { PhBhpViewSopobserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopobservation/public_api';
import { ObserveProtocal } from "../Models/ObserveProtocal"
import { SopStep, SelectedStep, Comments } from '../Models';
import { DatePipe } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-protocol',
  templateUrl: './ph-bhp-observe-protocol.component.html',
  styleUrls: ['./ph-bhp-observe-protocol.component.css'],
  providers: [DatePipe]
})
export class PhBhpObserveProtocolComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  userSubscription: Subscription;
  userData;
  isDesktop = true;
  noDataFound: boolean = false;
  modalRef: BsModalRef;
  seletedSteps: Array<Array<SelectedStep>> = [];
  comments: Array<Comments> = [];
  sopStep: Array<SopStep> = [];
  timeflag = '';
  timeLine = [];
  entryValue = [];
  entryFlag = 0;
  clickNoSterility: Boolean = false;
  showProfessionalSubcategory;
  formdata: any = {
    ward: {},
    department: {},
    category: {},
    subCategory: {}
  }
  userDataFlag = true;
  observeProtocal: Array<ObserveProtocal> = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;
  modalSubscription: Subscription;

  constructor(
    public config: AppConfig,
    private router: Router,
    private service: PhBhpFeaturePackageSopobservationService,
    public layoutService: PHBHPLayoutPackageService,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    if (this.config.userData) {
      this.userData = this.config.userData;
      this.OnUserChanges();
    }
    this.userSubscription = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.OnUserChanges();
    });

    this.layoutService.lang.subscribe((lang) => {
      this.reSetTime();
      // this.observeProtocal.forEach((value, index) => {
      //   this.setTimeLine(value, index);
      // });
      this.userDataFlag = true;
      this.OnUserChanges();
    });

    this.service.getConfigDetails(this.layoutService.institutionID).subscribe((res) => {
      if (res.enableProfessionalSubCategory) {
        this.showProfessionalSubcategory = res.enableProfessionalSubCategory;
      }
    });
  }

  OnUserChanges() {
    if (this.userData && this.userDataFlag) {
      this.userDataFlag = false;
      this.service.isCollapsed = true
      if (this.layoutService.institutionID)
        this.getSOPObservationProtocol()
      this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
        this.reSetTime();
        this.getSOPObservationProtocol()
      })
    }
  }

  reSetTime() {
    this.entryValue = [];
    this.entryFlag = 0;
    this.timeflag = '';
    this.timeLine = [];
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.userSubscription)
      this.userSubscription.unsubscribe();

    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  getSopName(observeID) {
    var tempTitle = this.translate.instant(this.observeProtocal.find(e => e.observationID === observeID).sopName);
    if (tempTitle == '' && this.translate.currentLang != this.translate.getDefaultLang()) {
      var prevLang = this.translate.currentLang;
      this.translate.use(this.translate.getDefaultLang());
      tempTitle = this.translate.instant(this.observeProtocal.find(e => e.observationID === observeID).sopName);
      this.translate.use(prevLang);
    }
    return tempTitle;

  }

  getDescription(observeID) {
    var tempDesc = this.translate.instant(this.observeProtocal.find(e => e.observationID === observeID).sopDescription);
    if (tempDesc == '' && this.translate.currentLang != this.translate.getDefaultLang()) {
      var prevLang = this.translate.currentLang;
      this.translate.use(this.translate.getDefaultLang());
      tempDesc = this.translate.instant(this.observeProtocal.find(e => e.observationID === observeID).sopDescription);
      this.translate.use(prevLang);
    }
    return tempDesc;

  }

  getSOPObservationProtocol() {
    this.layoutService.showLoader = true;
    this.service.getSOPObservationProtocol(this.userData.userId, this.userData.roleName.roleId, this.layoutService.institutionID, this.userData.country, this.translate.currentLang)
      .subscribe((res: Array<ObserveProtocal>) => {
        this.layoutService.showLoader = false;
        if (res.length == 0) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
        }
        this.observeProtocal = res;
        this.observeProtocal.forEach((value, index) => {
          
          this.setTimeLine(value, index)
        })
      })
  }

  setTimeLine(value, index) {
    var timeflag = value.createdDataTime.split("T")[0];
    if (this.timeflag == timeflag) {
      this.timeLine.push(false);
      this.entryValue[this.entryFlag]++;
      return;
    }

    this.entryValue[index] = 1;
    this.entryFlag = index;
    this.timeflag = timeflag

    if (index == 0) {
      var date = new Date();
      var dateFlag = date.toISOString().split("T")[0]
      if (dateFlag == timeflag) {
        this.timeLine.push(this.layoutService.translateText(this.translationKeys.Dashboard.Today));
        return;
      }
    }
    var lang = localStorage.getItem('selectedlanguage');
    var newDate = new Date(value.createdDataTime)
    var latest_date = newDate.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" });
    //var latest_date = this.datePipe.transform(value.createdDataTime, 'EEEE, dd LLLL yyyy');
    this.timeLine.push(latest_date);
  }

  viewOpobserve(index) {

    this.formdata = {
      ward: { wardName: this.observeProtocal[index].wardName },
      department: { departmentName: this.observeProtocal[index].departmentName },
      category: { categoryName: this.observeProtocal[index].professsionalCategory },
      subCategory: { subCategoryName: this.observeProtocal[index].professionalSubCategory }
    }

    var initialState = {
      isDesktop: true,
      userData: this.userData,
      formdata: this.formdata,
      sopStep: JSON.parse(this.observeProtocal[index].sopVersionStep),
      comments: JSON.parse(this.observeProtocal[index].observationComments),
      seletedSteps: JSON.parse(this.observeProtocal[index].observedJson),
      clickNoSterility: this.observeProtocal[index].noSterility,
      sopName: this.observeProtocal[index].sopName,
      sopDescription: this.observeProtocal[index].sopDescription,
      observationId: this.observeProtocal[index].observationID,
    };

    if (this.isDesktop) {
      this.modalSubscription = this.modalService.onHidden.subscribe((reason: string) => {
        this.getSOPObservationProtocol();
      });
      this.modalRef = this.modalService.show(PhBhpViewSopobserveComponent, { initialState, class: 'modal-full w-full' });
    } else {
      this.onChildData({ data: initialState, key: 'viewSop' });
    }
  }
  onChildData(event: any) {
    if (event.key !== 'viewSop') {
      this.router.navigate([event.key]);
    } else { /**/ }
  }

  errImg(e:Event){
    e.target['src'] = 'assets/img/fallback-img-gray.png';
  }
}
